
document.addEventListener('change', function(e) {
  const checkbox = e.target;

  if (checkbox.matches('.variant--quick__add-button input[type="checkbox"]')) {
    const checkboxes = checkbox.closest('ul').querySelectorAll('.variant--quick__add-button input[type="checkbox"]');

    if (checkbox.checked) {
      checkboxes.forEach(otherCheckbox => {
        if (otherCheckbox !== checkbox) {
          otherCheckbox.checked = false;
          otherCheckbox.closest('.variant--quick__add-button').classList.remove('checked');
        }
      });
      checkbox.closest('.variant--quick__add-button').classList.add('checked');
    } else {
      checkbox.closest('.variant--quick__add-button').classList.remove('checked');
    }
  }
});
